import * as R from 'ramda'
import { call, reducer, reset } from '../../helpers/api/meta'
import { getModuleByCourse } from '../../helpers/api/api'

export const GET_MODULE_BY_COURSE = 'GET_MODULE_BY_COURSE'

export const callGetModuleByCourse = (inputs) => {
  const meta = {
    endpoint: (params) => getModuleByCourse(params),
    inputs,
    action: GET_MODULE_BY_COURSE,
    messages: {
      id: 'getModuleByCourse',
      failure: 'Could not get course module',
    },
  }
  return call(meta)
}

const initialState = {
  loading: false,
  courseModule: {},
  enrolment: {},
}

const saveModuleCourseDetail = (state, action) => {
  if (action && action.results) {
    const course = { ...action.results }
    return R.assoc('courseModule', course, state)
  } else {
    return R.assoc('courseModule', action, state)
  }
}

export const callResetModuleByCourse = () => (dispatch) => {
  dispatch(reset(GET_MODULE_BY_COURSE)); 
  };

const messages = {
  loadFailed: 'Could not load modules.',
}

export default reducer(initialState, GET_MODULE_BY_COURSE, saveModuleCourseDetail, messages.loadFailed)
